export default "__VITE_ASSET__2ec36db1__"